<script setup lang="ts">
import {useLocalStorage, usePermission} from "@vueuse/core";
import {ref} from "vue";
import {useFirebaseApp} from "vuefire";
import {getMessaging, getToken, deleteToken} from "firebase/messaging";

const firebaseApp = useFirebaseApp()
const messaging = getMessaging(firebaseApp)
const api = useApi()
const {t} = useI18n()
const {user} = useAuth()

const vapidKey = 'BIdzU-wNj5Hk-zkih1uSEKyxMwSHmcvii-wzCr4El1yGIf3G2Qp3EiqF3ikDjDyq04Q_Lg2tmgLMZePKNqDz_Lw'

const tokenId = ref(useLocalStorage('notifications/tokenId', 0))
const notificationPermission = usePermission('notifications')

// Перевіряємо чи користувач в режимі імперсонейту
const isImpersonated = computed(() => {
  return !!user.value?.impersonatedBy
})

const pushEnabledSwitcher = computed(() => {
  return !!tokenId.value && notificationPermission.value === 'granted'
})

const loading = ref(false)
const subscribeError = ref(false)
const subscribeErrorText = ref('')

const activatePush = async () => {
  if (isImpersonated.value) {
    subscribeError.value = true
    subscribeErrorText.value = 'Пуш-сповіщення недоступні в режимі імперсонейту'
    return
  }

  try {
    const currentToken = await getToken(messaging, { vapidKey });
    if (currentToken) {
      tokenId.value = await api.notificationPushToken({request: {token: currentToken}});
    } else {
      console.error('token not created')
      subscribeError.value = true
      subscribeErrorText.value = 'Виникла помилка активації push-сповіщень. Спробуйте ще раз'
    }
  } catch (err) {
    console.error(err)
    subscribeError.value = true
    subscribeErrorText.value = 'Виникла помилка активації push-сповіщень. Спробуйте ще раз'
  }
}

const switchToggler = async () => {
  if (isImpersonated.value) {
    return
  }

  loading.value = 'warning'

  if (!pushEnabledSwitcher.value) {
    await activatePush()
  } else {
    deleteToken(messaging)
    tokenId.value = 0
  }

  loading.value = false
}

onMounted(async () => {
  if (!isImpersonated.value) {
    const result = await api.notificationCheckPushToken({id: tokenId.value})
    if (result === 0) {
      await activatePush()
    }
  }
})

</script>

<template>
  <v-switch 
    :label="t('appHeader.userMenu.pushNotifications')"
    color="primary" 
    :loading="loading" 
    @click="switchToggler" 
    v-model="pushEnabledSwitcher"
    :disabled="isImpersonated"
    hide-details
  ></v-switch>

  <v-snackbar :timeout="2000" elevation="24" v-model="subscribeError">
    {{ subscribeErrorText }}
  </v-snackbar>
</template>